const GetEApplicationUserStatusName = (id) => {
    switch (id) {
        case 0: { return "Active" }
        case 1: { return "Deactive" }
        case 2: { return "Blocked" }
        case 3: { return "Rejected" }
        case 4: { return "Pending" }
    }
}

const GetEApplicationUserStatus = {
    EApplicationUserStatus: [
        { Id: 0, Name: "Active" },
        { Id: 1, Name: "Deactive" },
        { Id: 2, Name: "Blocked" },
        { Id: 3, Name: "Rejected" },
        { Id: 4, Name: "Pending" },
    ]
}

const EApplicationUserStatusBg = (id) => {
    switch (id) {
        case 1: return "bg-red-400"
        case 2: return "bg-red-400"
        case 3: return "bg-red-400"
        case 0: return "bg-green-500"
        case 4: return "bg-orange-400"
    }
}

export { GetEApplicationUserStatusName, GetEApplicationUserStatus,EApplicationUserStatusBg }
